/* eslint-disable */
<div style="max-width:403px;max-height:300px" id="container123"></div>
<template>
    <section class="section section-white content-padded" onload="init()">
        <el-form ref="form" :model="form" label-width="110px">
            <el-form-item label="昵称">
                <el-input v-model="form.nickname" placeholder="昵称" style="width: 55%;"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="form.mobile" placeholder="手机号码" style="width: 55%;"></el-input>
            </el-form-item>

            <el-form-item label="店铺">
                <el-select v-model="form.distributor_name" filterable placeholder="请选择" remote :remote-method="getDistributorList" @change="handleDistibutorChange">
                    <el-option
                            v-for="item in distributorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
                <div v-show="false">
                    <el-col ><el-input v-model="form.inca_id" placeholder=""></el-input></el-col>
                </div>
            </el-form-item>
            <el-form-item label="直播流名称">
                <el-input v-model="form.stream_name" placeholder="直播流名称" style="width: 55%;"></el-input>
            </el-form-item>
            <el-form-item label="主播状态">
                <el-switch v-model="form.status" active-value="online" inactive-value="offline" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
            </el-form-item>
            <el-form-item label="是否启用">
                <el-switch v-model="form.disabled" active-value="0" inactive-value="1" active-color="#13ce66"  inactive-color="#ff4949"> </el-switch>
            </el-form-item>
            <div class="section-footer with-border content-center">
                <el-button size="large" @click="cancelSubmit">取消</el-button>
                <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
            </div>
        </el-form>
    </section>
</template>
<script>
    import { getDistributorList } from '../../../api/marketing'
    import {
        saveAnchor,
        getAnchorDetail,
    } from '../../../api/live'

    export default {
        data () {
            return {
                distributorList:[],
                submitLoading: false,
                form: {
                    anchor_id:'',
                    nickname:'',
                    inca_id:'',
                    mobile:'',
                    stream_name:'',
                    disabled:'',
                    status:'',
                    distributor_name:'',
                },

            }
        },
        methods: {
            cancelSubmit () {
                this.$router.go(-1)
                // this.$router.push({ path: this.matchInternalRoute('livelist'),query:{}})
            },
            submitItemsActionConfirm () {
                this.submitLoading = true
                saveAnchor(this.form).then(res => {
                    this.submitLoading = false
                    this.$message({ type: 'success', message: '保存成功'})
                    if (this.$store.getters.login_type != 'distributor') {
                        this.$router.go(-1)
                    }
                }).catch (error => {
                    this.submitLoading = false
                })
            },
            getDistributorList(val){
                getDistributorList({page: 1, pageSize: 50,name:val}).then(res => {
                    this.distributorList = [];
                    for (let item of res.data.data.list) {
                        this.distributorList.push({name: item.name, id: item.number})
                    }
                })
            },
            handleDistibutorChange:function (val){
                this.form.inca_id = val
            },
        },
        mounted () {
            this.anchor_id = this.$route.params.id
            getAnchorDetail(this.$route.params).then(res => {
                if(res.data){
                    if(this.anchor_id){
                        this.is_new = false;
                    }
                    res.data.data.disabled = res.data.data.disabled ?  '1' : '0';
                    this.form = res.data.data
                }
            });
            this.getDistributorList()
        }

    }
</script>

<style lang="scss">
    .bm-view {
        width: 100%;
        height: 300px;
    }
    #qqmap_rslist {
        border-right: 1px solid #e7e7eb;
    }
    #qqmap_container{
        float:left;
        width:800px;
        height:400px;
    }
    .checkbox {
        background-color: white;
        border-radius: 0px;
        border: 1px solid #d3d3d3;
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// add.vue?9969eaf0